import { CaseLabel } from "interfaces/case-label";
import { usePost } from "hooks/axios";

export interface PostLabelBody {
  name: string;
}

/** Provides a callback which can be used to save a chart in the API */
export const usePostCaseLabel = (): {
  loading: boolean;
  error: boolean;
  postCaseLabelCallback: (
    body: PostLabelBody
  ) => Promise<CaseLabel | undefined>;
} => {
  const { loading, error, postCallback } = usePost<PostLabelBody, CaseLabel>(
    "case_labels"
  );

  return { loading, error, postCaseLabelCallback: postCallback };
};
